import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useAuthUser } from '../../hooks/useAuthUser';
import { signInWithGoogle, signOutUser } from '../../lib/auth/authClient';

/**
 * Global header with route navigation and auth controls.
 */
export function SiteHeader() {
  const location = useLocation();
  const { user, isStaff } = useAuthUser();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  function toggleMenu() {
    setIsMenuOpen((currentValue) => !currentValue);
  }

  function closeMenu() {
    setIsMenuOpen(false);
  }

  function handleSignOut() {
    closeMenu();
    signOutUser();
  }

  function handleSignIn() {
    closeMenu();
    signInWithGoogle();
  }

  return (
    <header className="site-header glass">
      <div className="brand">
        <img
          className="brand-mark"
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt="Audio at Play logo"
          width="38"
          height="38"
          decoding="async"
        />
        <div className="brand-text">Audio at Play</div>
      </div>

      <button
        aria-controls="main-navigation"
        aria-expanded={isMenuOpen}
        aria-label="Toggle navigation menu"
        className="menu-toggle btn btn-ghost"
        onClick={toggleMenu}
        type="button"
      >
        <span className="menu-toggle-icon" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </button>

      <nav className={`site-nav ${isMenuOpen ? 'open' : ''}`} id="main-navigation" aria-label="Main Navigation">
        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMenu} to="/">
          Home
        </NavLink>
        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMenu} to="/shop">
          Shop
        </NavLink>
        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} onClick={closeMenu} to="/about">
          About
        </NavLink>
        <NavLink
          className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          onClick={closeMenu}
          to="/library"
        >
          My Library
        </NavLink>
        <NavLink
          className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          onClick={closeMenu}
          to="/account"
        >
          Account
        </NavLink>
        {isStaff ? (
          <NavLink
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            onClick={closeMenu}
            to="/admin"
          >
            Admin
          </NavLink>
        ) : null}
      </nav>

      <div className={`btn-row header-actions ${isMenuOpen ? 'open' : ''}`}>
        <WalletMultiButton className="btn btn-ghost wallet-connect-btn" />
        {user ? (
          <button className="btn btn-ghost" onClick={handleSignOut} type="button">
            Sign Out
          </button>
        ) : (
          <button className="btn btn-ghost" onClick={handleSignIn} type="button">
            Sign In
          </button>
        )}
      </div>
    </header>
  );
}
